module.exports = __webpack_public_path__ + "static/media/icon_menu_edi.1eb8d816.svg";